import type { TxOverview } from '../logic/createTxOverview'
import { Token } from '@/domain/types/Token'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'
import { testIds } from '@/ui/utils/testIds'

interface StakeTransactionOverviewProps {
  txOverview: TxOverview
  selectedToken: Token
}

function StakeTransactionOverview({ txOverview }: StakeTransactionOverviewProps) {
  if (txOverview.status !== 'success') {
    const placeholder = '-'

    return (
      <TransactionOverview providedBy="sky">
        <TransactionOverview.Row>
          <TransactionOverview.Label>Estimated rewards</TransactionOverview.Label>
          <TransactionOverview.Generic>{placeholder}</TransactionOverview.Generic>
        </TransactionOverview.Row>
        <TransactionOverview.Row>
          <TransactionOverview.Label>Outcome</TransactionOverview.Label>
          <TransactionOverview.Generic>{placeholder}</TransactionOverview.Generic>
        </TransactionOverview.Row>
      </TransactionOverview>
    )
  }
  const { apy, stakingToken, rewardToken, rewardsPerYear, outcome } = txOverview

  return (
    <TransactionOverview providedBy="sky">
      <TransactionOverview.Row>
        <TransactionOverview.Label>Estimated rewards</TransactionOverview.Label>
        <TransactionOverview.ApyWithRewards
          apy={apy}
          rewardsPerYear={rewardsPerYear}
          rewardToken={rewardToken}
          apyDataTestId={testIds.farmDetails.stakeDialog.transactionOverview.estimatedRewards.apy}
          rewardsPerYearDataTestId={testIds.farmDetails.stakeDialog.transactionOverview.estimatedRewards.description}
        />
      </TransactionOverview.Row>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Outcome</TransactionOverview.Label>
        <TransactionOverview.StakedInFarm
          token={stakingToken}
          amount={outcome.value}
          farmName={`${rewardToken.symbol} Farm`}
        />
      </TransactionOverview.Row>
    </TransactionOverview>
  )
}

export {
  StakeTransactionOverview as TransactionOverview,
  type StakeTransactionOverviewProps as TransactionOverviewProps,
}
